import { render, staticRenderFns } from "./ComplaintsList.vue?vue&type=template&id=106329b5&scoped=true"
import script from "./ComplaintsList.vue?vue&type=script&lang=js"
export * from "./ComplaintsList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsList.vue?vue&type=style&index=0&id=106329b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106329b5",
  null
  
)

export default component.exports